
import { message, Steps, Spin } from 'ant-design-vue';
import { defineAsyncComponent, defineComponent } from 'vue';
import { ArrowLeftOutlined, CheckCircleOutlined, FileSearchOutlined } from '@ant-design/icons-vue';
import Modal from '@/components/Modal.vue';
import { definitions } from '@/types/api';
import api from '@/axios/api';
import useAnalysisHooks from '@/hooks/analysis.hooks';
import { JobBasicInfo } from './js/jobBasicInfo';

export default defineComponent({
  name: 'AddJob',
  components: {
    aSteps: Steps,
    aStep: Steps.Step,
    aSpin: Spin,
    aModal: Modal,
    JobBasicInfoVue: defineAsyncComponent(() => import('./jobBasicInfo.vue')),
    JobAnalysisVue: defineAsyncComponent(() => import('./jobAnalysiss.vue')),
    ArrowLeftOutlined,
    CheckCircleOutlined,
    FileSearchOutlined,
  },
  data() {
    return {
      modalBack: false, // back-modal
      canFinish: false, // btn-disable
      currentStep: 0,
      steps: [
        {
          title: '作业信息',
          status: 'process',
        },
        {
          title: '分析模块',
          status: 'wait',
        },
      ],
      analysisHooks: useAnalysisHooks(),
    };
  },
  methods: {
    handleViewClick() {
      // this.$router.push({
      //   path: `/Teacher/jobPreview/${this.$route.params.jobId}`,
      //   query: {
      //     ...this.$route.params,
      //     id: this.$route.params.jobId,
      //     view: 'preview', // preview,see,submit
      //     redirect: this.$route.fullPath,
      //   },
      // });
      this.$router.push({
        path: '/Teacher/analysisAnswer',
        query: {
          view: 'preview', // preview,see,submit
          jobId: this.$route.params.jobId, // jobId这是教师端的作业id
          // assignmentId: record.id, // 这是分配表的id —— 预览不用分配id
          // assignmentModel: record.assignmentModel, // 分配模式 —— 学生submit才需要分配模式
        },
      });
    },
    handleComplete() {
      console.log(this);
      if (!this.canFinish) {
        message.success('保存成功');
        this.$router.push({
          path: '/Teacher/caseAnalysis',
        // path: this.$route.query.redirect as string,
        });
      }
    },
    async handleNext() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data: resData } = await ((this.$refs as any).info.jobBasicInfo as JobBasicInfo).saveJobBasicInfo();
      /** 需求：默认有一个模块一 */
      if (!this.$route.params.jobId) {
        const data = {
          assignmentId: resData.id as string,
          moduleName: '模块一',
          seq: 0,
        } as definitions['CustomQuestionModule']&{uid: string};
        await api.editCustomQuestionModule(data);
      }
      this.$nextTick(() => {
        this.steps[0].status = 'finish';
        this.steps[1].status = 'process';
        this.currentStep = 1;
      });
    },
    goBack() {
      this.modalBack = true;
      this.$router.push({
        path: this.$route.query.redirect as string,
      });
    },
    changeStep(step: number) {
      if (!this.$route.params.jobId) {
        message.error('请依次完成各模块内容');
      } else {
        this.steps[0].status = 'finish';
        this.steps[step].status = 'process';
        this.currentStep = step;
        this.analysisHooks.currentTeacherAssignmentStep.set(`${step}`);
      }
    },
    moduleChange(list: definitions['CustomQuestionModule'][]) {
      this.canFinish = list.some((v) => v.questionNumber === 0);
    },
  },
  mounted() {
    console.log(this.analysisHooks.currentTeacherAssignmentStep.get(), 'get mounted');
    if (this.analysisHooks.currentTeacherAssignmentStep.get() === '1') this.changeStep(1);
  },
  setup() {
    return {
    };
  },
});
